"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: " 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.43,14.49v-.61a2.76,2.76,0,0,1,.33-1.38A4.5,4.5,0,0,1,12,11.26a4.89,4.89,0,0,0,1.14-1,1.47,1.47,0,0,0,.28-.86.93.93,0,0,0-.4-.82,1.85,1.85,0,0,0-1.1-.28A6.3,6.3,0,0,0,9.1,9.1L8.2,7.29a8,8,0,0,1,3.9-1,4.18,4.18,0,0,1,2.7.82,2.68,2.68,0,0,1,1,2.18,2.93,2.93,0,0,1-.41,1.56,6,6,0,0,1-1.57,1.48,4.84,4.84,0,0,0-1,.89,1.4,1.4,0,0,0-.21.8v.5Zm-.27,2.81a1.39,1.39,0,0,1,.37-1,1.5,1.5,0,0,1,1.08-.36,1.43,1.43,0,0,1,1.06.37,1.36,1.36,0,0,1,.38,1,1.39,1.39,0,0,1-.38,1,1.46,1.46,0,0,1-1.06.37,1.49,1.49,0,0,1-1.07-.36A1.4,1.4,0,0,1,10.16,17.3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,21.56A9.56,9.56,0,1,1,21.56,12,9.57,9.57,0,0,1,12,21.56Z"
  }));
};

exports["default"] = _default;